// Secure cookie utilities for enhanced security
export interface SecureCookieOptions {
  maxAge?: number;
  httpOnly?: boolean;
  secure?: boolean;
  sameSite?: 'strict' | 'lax' | 'none';
  path?: string;
}

export const setSecureCookie = (
  name: string, 
  value: string, 
  options: SecureCookieOptions = {}
): void => {
  if (typeof document === 'undefined') return;

  const {
    maxAge = 60 * 60 * 24 * 7, // 7 days default
    httpOnly = true,
    secure = true,
    sameSite = 'lax',
    path = '/'
  } = options;

  let cookieString = `${name}=${value}; path=${path}; max-age=${maxAge}`;
  
  if (httpOnly) {
    cookieString += '; HttpOnly';
  }
  
  if (secure) {
    cookieString += '; Secure';
  }
  
  cookieString += `; SameSite=${sameSite}`;

  document.cookie = cookieString;
};

export const getSecureCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null;

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  
  return null;
};

export const deleteSecureCookie = (name: string, path: string = '/'): void => {
  if (typeof document === 'undefined') return;
  
  document.cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};